export default __webpack_public_path__ + "static/media/icon-relacao-receita-b2.ab2df6cb.svg";